<template>
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="animate-spin"
  >
    <!-- Yttre cirkel -->
    <path
      d="M16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9ZM4.12201 9C4.12201 11.694 6.30596 13.878 9 13.878C11.694 13.878 13.878 11.694 13.878 9C13.878 6.30596 11.694 4.12201 9 4.12201C6.30596 4.12201 4.12201 6.30596 4.12201 9Z"
      :fill="'white'"
    />
    <!-- Loader-segment -->
    <path
      d="M6.57426 16.097C7.69449 16.4798 8.88944 16.5921 10.0614 16.4245C11.2333 16.2569 12.3489 15.8143 13.3169 15.1328C14.285 14.4514 15.078 13.5504 15.631 12.5037C16.184 11.457 16.4814 10.2942 16.4989 9.11048C16.5163 7.92676 16.2533 6.75573 15.7313 5.69317C15.2094 4.63061 14.4433 3.7067 13.4957 2.99702C12.5482 2.28734 11.4461 1.81205 10.2796 1.61002C9.11313 1.40799 7.9154 1.48497 6.78437 1.83465L7.55885 4.33967C8.29447 4.11224 9.07348 4.06217 9.83215 4.19357C10.5908 4.32497 11.3076 4.6341 11.9239 5.09567C12.5402 5.55725 13.0385 6.15816 13.3779 6.84924C13.7174 7.54033 13.8885 8.30197 13.8772 9.07186C13.8658 9.84174 13.6724 10.598 13.3127 11.2788C12.953 11.9596 12.4372 12.5456 11.8076 12.9888C11.178 13.432 10.4524 13.7199 9.69021 13.8289C8.92799 13.9379 8.1508 13.8649 7.4222 13.6159L6.57426 16.097Z"
      :fill="'url(#loader-gradient)'"
    />

    <!-- Gradient bara när den inte är disabled -->
    <defs>
      <linearGradient
        id="loader-gradient"
        x1="13.1247"
        y1="14.2498"
        x2="12.3702"
        y2="3.78744"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#898989" />
        <stop offset="1" stop-color="#ffffff" stop-opacity="0" />
      </linearGradient>
    </defs>
  </svg>
</template>


<script>

export default {
  name: 'IconLoader',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },

  },
};
</script>
